import { render, staticRenderFns } from "./auth-agb-privacy-info.vue?vue&type=template&id=4ade24d4&"
import script from "./auth-agb-privacy-info.vue?vue&type=script&lang=js&"
export * from "./auth-agb-privacy-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports